<template>
	<core-layout-headline-with-tabs :tabs="tabs">
		{{ $t("product") }}
	</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			const enabledSettings = this.$store.state.settings.products || {}
			let possibleFields = [
				{
					id: "overview",
					name: this.$t("overview"),
					to: { name: "ProductDetail", params: { ...this.$route.params } }
				}
			]

			if (enabledSettings.hasBenefitsEditor)
				possibleFields.push({
					id: "benefits",
					name: `${this.$t("benefits")}`,
					to: { name: "ProductBenefits", params: { ...this.$route.params } }
				})
			if (enabledSettings.hasUnderwritingEditor)
				possibleFields.push({
					id: "underwriting",
					name: this.$t("underwriting"),
					to: { name: "ProductUnderwriting", params: { ...this.$route.params } }
				})
			if (enabledSettings.hasPricingEditor)
				possibleFields.push({
					id: "pricing",
					name: this.$t("pricing"),
					to: { name: "ProductPricing", params: { ...this.$route.params } }
				})

			return possibleFields
		}
	}
}
</script>
